import 'imask/esm';
export { default as IMask } from 'imask/esm/imask';
export { default as IMaskComponent } from './component.js';
export { default as IMaskDirective } from './directive.js';
export { default as useIMask } from './composable.js';
export { default as IMaskProps } from './props.js';
import 'vue-demi';
import './component3-composition.js';
import './utils.js';
import './component2.js';
